import React from "react";
import { SectionHeading } from "./SectionHeading";
import { differentiators } from "../../data/content";
const accents = ["#1C2F4F", "#4A7556", "#1F6B73", "#B4676B", "#9C7C17", "#2D3033"];
export function Differentiation() {
  return <section className="w-full border-t border-navy/10 bg-white px-5 py-14 md:py-20" data-id="element-73" data-mp="2bcpbil84b3ls">
      <div className="mx-auto max-w-5xl" data-id="element-74" data-mp="26fgtqlqvt1l2">
        <SectionHeading title={<>This isn’t just another <span className="text-rose" data-id="element-76" data-mp="1ip3clq9u4n59">prenatal fitness ebook</span></>} subtitle={<span className="font-display text-base font-extrabold uppercase text-teal" data-id="element-77" data-mp="1dqjpvnnf37bu">It’s a complete ready-to-coach training system.</span>} data-id="element-75" data-mp="1iol7031a8wko" />
        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-78" data-mp="1skehlgvfyfzt">
          {differentiators.map((d, i) => <li key={d.title} className="flex h-full flex-col rounded-xl border border-navy/10 border-t-4 p-5" style={{
          borderTopColor: accents[i]
        }} data-id="element-79" data-mp="341nxxuj9wrww" data-mpi={i}>
              <span className="font-display text-2xl font-black" style={{
            color: accents[i]
          }} data-id="element-80" data-mp="2z2bbvc087ovd">{i + 1}</span>
              <h3 className="mt-1 font-display text-sm font-black uppercase leading-snug text-navy" data-id="element-81" data-mp="g23p3qcp3x10">{d.title}</h3>
              <p className="mt-1.5 text-sm text-navy/75" data-id="element-82" data-mp="l39i7pa9pmb2">{d.text}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}